import { render } from "./ColoredLinks.vue?vue&type=template&id=67fd0628"
import script from "./ColoredLinks.vue?vue&type=script&lang=js"
export * from "./ColoredLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__